module.exports = __webpack_public_path__ + "img/echno_is.862fb3ba.png";